import MeasureShow from "../components/measure/Show";

export default [
  { name: 'Measure', path: '/measure', component: MeasureShow,  }
]
